export default {
  user: {
    deleteConfirmation: "Are you sure you want to delete this user?",
    name: "Full name",
    email: "Email",
    roles: "Roles",
    emailVerified: "Email verified",
    projects: "Projects",
    verified: "Verified",
    notVerified: "Not verified",
    filter: {
      title: "Filter users",
      state: "User status",
      selectState: "Select a status",
      roles: "Roles",
      apply: "Filter",
    },
    edit: {
      title: "Edit a user",
      name: "Last name",
      firstname: "First name",
      email: "Email",
      roles: "Roles",
      save: "Edit",
    },
  }
}
